import { AbstractScatterVisualization } from './../visualization.abstract.scatter.component';
export class PcaIncrementalGraph extends AbstractScatterVisualization {
}
